module.exports = __webpack_public_path__ + "img/art-4-3-stereotyping.31da1829.jpg";